'use strict';

var _require = require('./Component'),
    DebounceInput = _require.DebounceInput;

DebounceInput.DebounceInput = DebounceInput;

module.exports = DebounceInput;


//////////////////
// WEBPACK FOOTER
// ./~/react-debounce-input/lib/index.js
// module id = 963
// module chunks = 0